import { render, staticRenderFns } from "./RelationshipButtons.vue?vue&type=template&id=58e5ef76&"
import script from "./RelationshipButtons.vue?vue&type=script&lang=js&"
export * from "./RelationshipButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e5ef76')) {
      api.createRecord('58e5ef76', component.options)
    } else {
      api.reload('58e5ef76', component.options)
    }
    module.hot.accept("./RelationshipButtons.vue?vue&type=template&id=58e5ef76&", function () {
      api.rerender('58e5ef76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/hotels/hotel/RelationshipButtons.vue"
export default component.exports